export enum UserField {
  Id = 'id',
  FullName = 'full_name',
  Email = 'email',
  ActivatedDate = 'activated_date',
  InvitationDate = 'last_invitation_date',
  LastLoginDate = 'last_login_date',
  Status = 'status',
}

export enum AuditLogField {
  Id = 'id',
  CreatedAt = 'created_at',
  FieldName = 'field_name',
}
